import React from "react";
import AppHeader from "@/components/drill/AppHeader";
import ThemeSection from "@/components/drill/ThemeSection";
import DeleteAccountSection from "@/components/drill/DeleteAccountSection";
import DeletionRequestsSection from "@/components/drill/DeletionRequestsSection";
import { useAuth } from "@/lib/AuthContext";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { LogOut, Scale } from "lucide-react";
import CompanyDetailsSection from "@/components/drill/CompanyDetailsSection";
export default function Settings() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900">
      <AppHeader
        title="Settings"
        subtitle="App preferences"
        backTo="/dashboard"
      />
      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-8 pb-24 space-y-6">
        <ThemeSection />
        <CompanyDetailsSection />

        <section className="rounded-xl border bg-white p-4 shadow-sm dark:bg-slate-900">
          <div className="flex flex-col items-start gap-3">
            <div className="w-full">
              <h2 className="font-semibold">Legal &amp; Security</h2>
              <p className="text-sm text-muted-foreground">Privacy, terms, licence, company information, open-source notices and data security.</p>
            </div>
            <Button variant="outline" className="rounded-xl" onClick={() => navigate('/legal')}>
              <Scale className="mr-2 h-4 w-4" />
              View Legal &amp; Security
            </Button>
          </div>
        </section>

        <section className="rounded-xl border bg-white p-4 shadow-sm dark:bg-slate-900">
          <div className="flex flex-col items-start gap-3">
            <div className="w-full">
              <h2 className="font-semibold">Account</h2>
              <p className="text-sm text-muted-foreground">Sign out of DrillLogPro on this device.</p>
            </div>
            <Button variant="destructive" onClick={handleLogout}>
              <LogOut className="mr-2 h-4 w-4" />
              Log out
            </Button>
          </div>
        </section>

        <DeletionRequestsSection />
        <DeleteAccountSection />
      </main>
    </div>
  );
}